import flow from "lodash/fp/flow";
import map from "lodash/fp/map";
import find from "lodash/fp/find";
import constants from "../../core/constants";
import moment from "moment";
import { isNil } from "lodash/fp";
import { toObject, isDateAfter } from "../../core/utils";
class CustomerPageTransform {
  constructor(TransactionsOps, Lists) {
    "ngInject";

    this.Lists = Lists.all;
    this.TransactionsOps = TransactionsOps;

    this.customerTransactionFields = [
      { title: "Date", name: "createdAt" },
      { title: "Total Amount", name: "totalAmount" },
      { title: "Operation", name: "op" },
      { title: "Method", name: "method" },
    ];
  }

  justify(data) {
    const role = (item) => {
      item.role = find((i) => i.name === item.role)(this.Lists.roles);
      item.corpRole = find((i) => i.name === item.corpRole)(
        this.Lists.corpRoles
      );
      return item;
    };

    // Force disable corporate for all user
    const corporate = (item) => {
      if (!isNil(item.corporate)) item.corporate.isDisabled = true;
      return item;
    };

    const formatDate = (item) => {
      item.date = moment(item.date).format(constants.dateTimeFormat);
      item.createdAt = moment(item.createdAt).format(constants.dateTimeFormat);

      return item;
    };

    const formatNumber = (item) => {
      item.phone = Number(item.phone);

      return item;
    };

    const formatBalance = (item) => {
      item.balance.creditAmount /= constants.currencyBy;
      item.balance.debt.pendingAmount /= constants.currencyBy;
      item.balance.debt.unfulfilledAmount /= constants.currencyBy;

      return item;
    };

    const statusValues = {
      subscribed: "Subscribed",
      unsubscribed: "Unsubscribed",
      cancelled: "Canceled",
      pending: "Pending",
      expired: "Expired",
    };

    const justifyPackageSubscription = (item) => {
      if (!isNil(item.package_subscription)) {
        item.package_subscription.status =
          statusValues[item.package_subscription.status] ||
          item.package_subscription.status;
        if (item.package_subscription.status !== "Unsubscribed") {
          item.package_subscription.active_date =
            item.package_subscription.active_date &&
            moment(item.package_subscription.active_date).format(
              constants.dateFormat
            );
          item.package_subscription.price.amount /= constants.currencyBy;
          item.package_subscription.flat_fee_value /= constants.currencyBy;
          item.package_subscription.expiry_date =
            item.package_subscription.expiry_date &&
            moment(item.package_subscription.expiry_date).format(
              constants.dateFormat
            );
          item.package_subscription.fawry_expiry_date =
            item.package_subscription.fawry_expiry_date &&
            moment(item.package_subscription.fawry_expiry_date).format(
              constants.dateTimeFormat
            );
          item.package_subscription.package_duration += " Day(s)";
          item.package_subscription.remaining_days += " Day(s)";
          item.package_subscription.percentage_discount_maximum /=
            constants.currencyBy;
          item.package_subscription.package_type = item.package_subscription.package_type
            .split("_")
            .join(" ");
        }
      }
      if (isNil(item.roles)) {
        item.roles = [];
      } else {
        item.roles = item.roles.map((role) => {
          return { name: role.name, reference_id: role.reference_id };
        });
      }
      return item;
    };

    const formatResetToken = (item) => {
      if (item.preferences && item.preferences.reset_token) {
        const WEBSITEURL = process.env.WEBSITE_URL;
        item.preferences.reset_expiry = moment(
          item.preferences.reset_expiry
        ).format("DD MMMM YYYY hh:mm a");
        item.preferences.reset_token = `${WEBSITEURL}reset_password.html?token=${item.preferences.reset_token}`;
        item.preferences.resetPasswordExpired = isDateAfter(
          item.preferences.reset_expiry
        );
      }

      return item;
    };

    return toObject(
      flow([
        role,
        corporate,
        formatDate,
        formatNumber,
        formatBalance,
        justifyPackageSubscription,
        formatResetToken,
      ])(data)
    );
  }

  justifyNotes(data) {
    const format = (item) => {
      item = Object.assign({}, item._source, { _id: item._id });
      item.comment = { value: item.comment, isDisabled: true };
      item.createdAt = moment(item.createdAt).format(constants.dateTimeFormat);

      return item;
    };
    return map(format)(data);
  }

  justifyTransactions(data) {
    const format = (item) => {
      item.totalAmount /= constants.currencyBy;
      item.createdAt = moment(item.createdAt).format(constants.dateTimeFormat);
      item.subTransactions =
        item.subTransactions && item.subTransactions.length
          ? item.subTransactions.forEach((sub) => {
              item.method = sub.card
                ? { method: "card" }
                : sub.debt
                ? { method: "cash" }
                : { method: "credit" };
            })
          : [];
      item.op = this.TransactionsOps.ops[item.operation];

      return item;
    };
    return map(format)(data);
  }
}

export default CustomerPageTransform;



// WEBPACK FOOTER //
// ./src/pages/customer/customer.transforms.js